import { render, staticRenderFns } from "./AuthConfirm.vue?vue&type=template&id=73818fa4&scoped=true&"
import script from "./AuthConfirm.vue?vue&type=script&lang=js&"
export * from "./AuthConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AuthConfirm.vue?vue&type=style&index=0&id=73818fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73818fa4",
  null
  
)

export default component.exports